import { CSSProperties } from 'react'

import Tooltip from 'components/ui/Tooltip'

function Hint({ tooltipText, classNames = '', style = {} }: Props) {
  const className = ['u-clickable hint', classNames].join(' ')
  return (
    <Tooltip text={tooltipText}>
        <div style={style} className={className}>
          ?
        </div>
      </Tooltip>
  )
}

type Props = {
  tooltipText: JSX.Element
  classNames?: string
  style?: CSSProperties
}

export default Hint
